import { PlanShared } from './../../../general/shared/plan-shared';
import { BottomsheetShared } from './../../../general/shared/bottomsheet-shared';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PersoanlService } from 'src/app/data/repository/plan-repository/persoanl.service';

@Component({
  selector: 'app-main-personal',
  templateUrl: './main-personal.component.html',
  styleUrls: ['./main-personal.component.scss'],
})
export class MainPersonalComponent implements OnInit, OnDestroy {
  title: string;
  dietId: string;
  day: string;
  meal: string;
  showBTM: boolean = false;
  subscription1: Subscription;

  constructor(
    private planService: PlanService,
    private route: ActivatedRoute,
    private persoanlService: PersoanlService,
    private bottomsheetShared: BottomsheetShared,
    private planShared: PlanShared
  ) {
    this.day = this.route.snapshot.paramMap.get('day');
    this.dietId = this.route.snapshot.paramMap.get('dietId');
    this.meal = this.route.snapshot.paramMap.get('meal');
    if (this.meal == 'breakfast') {
      this.title = 'صبحانه';
    } else if (this.meal == 'snack1') {
      this.title = ' میان‌وعده اول';
    } else if (this.meal == 'lunch') {
      this.title = 'ناهار';
    } else if (this.meal == 'snack2') {
      this.title = ' میان‌وعده دوم';
    } else if (this.meal == 'snack3') {
      this.title = ' میان‌وعده سوم';
    }
    this.loadPersonals();
    this.subscription1 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showBTM = false;
        }
      }
    );
    if (
      !this.planShared.selectedMeal ||
      !this.planShared.selectedDietDayFoodLogs
    ) {
      this.back();
      return;
    }
  }
  async loadPersonals() {
    await this.persoanlService.getPersonalFood();
    await this.persoanlService.getPersonalPackage();
  }
  addQuikC() {
    this.showBTM = true;
  }
  ngOnDestroy() {
    this.subscription1.unsubscribe();
  }
  ngOnInit() {}
  back() {
    this.planService.goBack();
  }
  goToPersonalFoodMain() {
    this.planService.goToPersoanlFoodMain(this.dietId, this.day, this.meal);
  }
  goToPersonalPackageMain() {
    this.planService.goToPersonalPackageMain(this.dietId, this.day, this.meal);
  }
  goSearch() {
    this.planService.goToAddFood(this.dietId, this.day, this.meal);
  }
}
